import { useCallback } from 'react'
import { usePost } from '../apiHooks'
import { config } from '../../components/Init/Init'
import { tokenizer } from '../../services/utils'
import { usePlayerStore } from '../../services/store'

export const useSaveAccountSsn = onSsnDataSaveSuccess => {
  const playerStore = usePlayerStore()
  const playerLoginUser = playerStore.use.loginUser()

  const { POST, isLoading: isSaveAccountSsnLoading } = usePost()

  const getTaxInfoUrl = tokenizer(config.kycServiceTaxUrl + config.sendAccountTaxInfo, {
    '{userId}': playerLoginUser.userId
  })

  const saveAccountSsn = useCallback(
    ({ taxId }) => {
      if (isSaveAccountSsnLoading) return

      const normalizeTaxId = taxId.replace(/-/g, '')

      POST(getTaxInfoUrl, { taxId: normalizeTaxId })
        .then(data => {
          onSsnDataSaveSuccess(data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    [POST, getTaxInfoUrl, onSsnDataSaveSuccess]
  )

  return { saveAccountSsn, isSaveAccountSsnLoading }
}
